/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Guides_RelatedInputs */

const en_wc_guides_related = /** @type {(inputs: Wc_Guides_RelatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep learning`)
};

/**
* | output |
* | --- |
* | "Keep learning" |
*
* @param {Wc_Guides_RelatedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_guides_related = /** @type {((inputs?: Wc_Guides_RelatedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Guides_RelatedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_guides_related(inputs)
});
export { wc_guides_related as "wc.guides.related" }